import React, { useState } from "react";
import classes from "./Layout.module.css";
import chevronIcon from "../../icons/chevron.svg";
const Layout = (props) => {
  const [hovered, setHovered] = useState(false);

  let svgClasses = [classes.chevron];
  if (hovered) {
    svgClasses.push(classes.chevronHovered);
  }

  return (
    <div className="app">
      {props.goBack && (
        <button
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => props.goBack()}
          className={classes.backButton}
        >
          <img
            style={{ margin: "0.5rem" }}
            className={svgClasses.join(" ")}
            src={chevronIcon}
            width={50}
            height={50}
          />
        </button>
      )}
      {props.children}
    </div>
  );
};

export default Layout;
